import apiClient from "config/apiClient";
import { MstItemDetailWheelSelectResponse } from "../types";

export const WHEEL_URL = {
  WHEEL_DETAIL: "/mst/item/detail/wheel/select",
};

export interface WheelDetailRequest {
  item_cd: string;
  wheel_width?: string;
  wheel_inset_from?: string;
  wheel_inset_to?: string;
  wheel_pcd?: string;
  wheel_hole?: string;
  tire_width?: number;
  tire_aspect_ratio?: number;
  tire_rim_diam?: string;
  tire_category?: string;
  maker_names?: string[];
  recommend_flag?: boolean;
  tire_loin_speed_mark?: string;
  brand_name?: string;
  maker_name?: string;
  wheel_color_names?: string[];
  winter_flag?: string[];
  limit?: number;
  offset?: number;
}

/**
 * Fetches wheel detail information by item code.
 * @param body - The request payload containing wheel detail search parameters.
 * @returns A promise resolving to the wheel detail response.
 */
const getWheelDetailByCodeApi = async (
  body: WheelDetailRequest,
): Promise<MstItemDetailWheelSelectResponse> => {
  const newBody = {
    ...body,
    maker_names: body.maker_names?.join(",") || undefined,
    wheel_color_names: body.wheel_color_names?.join(",") || undefined,
    winter_flag: body.winter_flag?.join(",") || undefined,
  };

  const res = await apiClient.post<MstItemDetailWheelSelectResponse>(
    WHEEL_URL.WHEEL_DETAIL,
    newBody,
  );
  return res.data!;
};

export default getWheelDetailByCodeApi;
